import { render, staticRenderFns } from "./RemoveRuleForever.vue?vue&type=template&id=ef6d1dbe&scoped=true&"
import script from "./RemoveRuleForever.vue?vue&type=script&lang=js&"
export * from "./RemoveRuleForever.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6d1dbe",
  null
  
)

export default component.exports